module.exports = __webpack_public_path__ + "static/zenith-4972190a68173e566895c0ba5e3a4764.png";